<div class="spec-table">
  @if (specTableData$ | async; as specTableData) { @if (specTableData?.specTable?.productValues) {
  <mat-expansion-panel>
    <mat-expansion-panel-header class="pdp-spec-table-header">
      <mat-panel-title class="pdp-spec-table-label">
        {{ 'product.productOptions.productSpecTable.title' | cxTranslate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="spec-table-body">
      <table>
        <thead>
          <tr>
            @for (headerId of specTableData.specTable.productHeaders; track headerId) {
            <th>{{ headerId.headerName }}</th>
            }
            <th>{{ 'product.productList.dealerPrice' | cxTranslate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (value of specTableData.specTable.productValues; track value) {
          <tr>
            @for (headerId of specTableData.specTable.productHeaders; track headerId) {
            <td>{{ checkTableId(value.values, headerId) }}</td>
            }
            <td>{{ dealerPrice(value.code) }}</td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </mat-expansion-panel>
  } }
</div>
